import firebase from 'firebase/app';
import 'firebase/firestore'
import 'firebase/auth'

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
    apiKey: "AIzaSyCZAFRC1CmXuKBCJ5jP9GK1gg-AFlxtMXM",
    authDomain: "planner-f9a26.firebaseapp.com",
    projectId: "planner-f9a26",
    storageBucket: "planner-f9a26.appspot.com",
    messagingSenderId: "53243081397",
    appId: "1:53243081397:web:b61bb9de05fc50a6f504fc",
    measurementId: "G-ZPYGQDZ98W"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
//firebase.analytics();
firebase.firestore().settings({timestampsInSnapshots:true})
export default firebase; 